import React from 'react'

import BasicEmailAlert from 'email-server/BasicEmailAlert'

const DailyEmail = ({data}) => (
  <BasicEmailAlert data={data} config={{timeFrameDays: 1}} />
)
export default DailyEmail
